export default "__VITE_ASSET__CrRZxSMh__"